export function getStrRes(resID) {
    let langID = this.$route.params.langID;
    if (langID === void 0 || langID === null || langID === '') {
        langID = 'en'
    }
    let resMap = void 0;
    if (langID !== 'en' && this.mlStrResMap.has(langID)) {
        resMap = this.mlStrResMap.get(langID);
    } else {
        resMap = this.mlStrResMap.get('en');
    }
    let res = resMap.get(resID);
    if (res === void 0 || res === null) {
        res = this.mlStrResMap.get('en').get(resID);
        if (res === void 0 || res === null) {
            res = 'Unknown';
        }
    }
    return res
}

export function getUrlStr(suffix) {
    let langID = this.$route.params.langID
    // console.log(langID)
    if (langID === void 0 || langID === null || langID === '') {
        langID = ''
    } else {
        langID = '/' + langID
    }
    return langID + suffix
}

export function isLangID(langID) {
    let rLangID = this.$route.params.langID
    console.log(rLangID)
    if (rLangID === langID) {
        return true
    }
    return false
}


// WEBPACK FOOTER //
// ./src/util/MultiLang.js